export const ERROR_GET_USERS = {
  pt: "Erro ao buscar usuários",
  es: "Error al buscar usuarios",
  en: "Error searching users",
};

export const ERROR_DOWNLOAD_FILE = {
  pt: "Não foi possível fazer o download do arquivo",
  es: "No se pudo descargar el archivo",
  en: "It was not possible to download the file",
};

export const ERROR_CREATE_FILE = {
  pt: "Não foi possível gerar o arquivo para download",
  es: "No se pudo generar el archivo descargable",
  en: "It was not possible to generate the file for download",
};

export const ERROR_GET_CHARGES_USERS = {
  pt: "Erro ao buscar as cargas do usuário",
  es: "Error al buscar las cargas del usuario",
  en: "Error searching users' charges",
};

export const ERROR_GET_USERS_CARS = {
  pt: "Erro ao buscar os carros do usuário",
  es: "Error al buscar los automóviles del usuario",
  en: "Error searching users' cars",
};

export const LOADING_USER = {
  pt: "Buscando usuário ...",
  es: "Buscando usuario ...",
  en: "Searching user ...",
};

export const USER_NOT_FOUND = {
  pt: "Usuário não encontrado",
  es: "Usuario no encontrado",
  en: "User not found",
};

export const ADMIN = {
  pt: "Admin",
  es: "Admin",
  en: "Admin",
};

export const USERS = {
  pt: "Usuários",
  es: "Usuarios",
  en: "Users",
};

export const TRANSFER_BALANCE = {
  pt: "Transferir Saldo",
  es: "Transferir Saldo",
  en: "Transfer balance",
};

export const SEARCH_BY_EMAIL = {
  pt: "Pesquise pelo email...",
  es: "Busque por el correo electrónico...",
  en: "Search by email...",
};

export const EMAIL_EXAMPLE = {
  pt: "nome@mail.com",
  es: "nombre@mail.com",
  en: "name@mail.com",
};

export const NAME_EXAMPLE = {
  pt: "Nome do usuário",
  es: "Nombre del usuario",
  en: "User name",
};

export const SEARCH_BY_DOCUMENT = {
  pt: "Pesquise pelo documento (CPF, DNI, etc)...",
  es: "Busque por el documento (CPF, DNI, etc)...",
  en: "Search by document (CPF, DNI, etc)...",
};

export const DOCUMENT_EXAMPLE = {
  pt: "CPF, DNI ou outros",
  es: "CPF, DNI o otros",
  en: "CPF, DNI or others",
};

export const SEARCH_BY_DOCUMENTS = {
  pt: "Você pode pesquisar por e-mail, nome, documento ou telefone.",
  es: "Puedes buscar por correo electrónico, nombre, documento o telefono.",
  en: "You can search by email, name, document or phone.",
};

export const SEARCH_BY_PHONE = {
  pt: "Pesquise pelo telefone...",
  es: "Busque por el telefono...",
  en: "Search by phone...",
};

export const PHONE_EXAMPLE = {
  pt: "(00) 91234-5678",
  es: "(00) 91234-5678",
  en: "(00) 91234-5678",
};

export const SEARCH = {
  pt: "Pesquisar",
  es: "Buscar",
  en: "Search",
};

export const SEARCH_DOCUMENTS = {
  pt: "Pesquisar por",
  es: "Buscar por",
  en: "Search for",
};
export const CLEAN = {
  pt: "Limpar",
  es: "Limpiar",
  en: "Clear",
};

export const FILTER = {
  pt: "Filtrar",
  es: "Filtrar",
  en: "Filter",
};

export const CSV_FILE_NAME = {
  pt: "usuarios_cargas.csv",
  es: "usuarios_cargas.csv",
  en: "users_charges.csv",
};

export const CSV_FILE_NAME_HISTORY = (DATA, USER_ID) => ({
  pt: `Histórico de cargas_${DATA} - Usuário_${USER_ID}`,
  es: `Historial de cargas_${DATA} - Usuario_${USER_ID}`,
  en: `User charges history_${DATA} - User_${USER_ID}`,
});

export const MONTH_TIME = {
  pt: "L HH[h]mm",
};

export const DOWNLOAD_CSV = {
  pt: "Baixar lista de usuários em Excel",
  es: "Descargar lista de usuarios en Excel",
  en: "Download users list in Excel",
};

export const DOWNLOAD_CHARGES_CSV = {
  pt: "Baixar cargas do usuário em Excel",
  es: "Descargar cargas del usuario en Excel",
  en: "Download users' charges in Excel",
};

// TODO: translate properly
export const LOADING_USER_CHARGES = {
  pt: "Buscando cargas do usuário ...",
  es: "Buscando cargas del usuario ...",
  en: "Searching users' charges ...",
};

export const ENERGY = {
  pt: "Energia",
  es: "Energía",
  en: "Energy",
};

export const CHARGE_SESSION_STATUS_LABEL = {
  pt: "Status",
  es: "Estado",
  en: "Status",
};

export const CHARGE_SESSION_STATUS_VALUE = {
  pt: {
    initiating: "Iniciando",
    initiated: "Iniciado",
    rejected: "Rejeitado pela estação",
    accepted: "Aceito pela estação",
    timed_out: "Sem resposta da estação",
    invalid: "Falha na Integração com a Estação",
    active: "Carregando",
    idle: "Ociosa",
    stop_requested: "Encerramento solicitado, aguardando estação",
    completed:
      "Carga encerrada, aguardando processamento (acione suporte de tecnologia)",
    processing_payment: "Processando pagamento",
    payment_failed: "Falha no pagamento",
    payment_success: "Pagamento realizado com sucesso",
    finished: "Processamento e Carga Finalizada",
  },
  es: {
    initiating: "Iniciando",
    initiated: "Iniciado",
    rejected: "Rechazado por la estación",
    accepted: "Aceptado por la estación",
    timed_out: "Sin respuesta de la estación",
    invalid: "Error en la integración con la estación",
    active: "Cargando",
    idle: "Inactiva",
    stop_requested: "Detención solicitada, esperando la estación",
    completed:
      "Carga encerrada, aguardando processamento (acione suporte de tecnologia)",
    processing_payment: "Procesando pago",
    payment_failed: "Error en el pago",
    payment_success: "Pago realizado con éxito",
    finished: "Procesamiento y carga finalizada",
  },
  en: {
    initiating: "Initiating",
    initiated: "Initiated",
    rejected: "Rejected by station",
    accepted: "Accepted by station",
    timed_out: "No response from station",
    invalid: "Station Integration Failure",
    active: "Charging",
    idle: "Idle",
    stop_requested: "Stop requested, waiting for station",
    completed:
      "Charge completed, waiting for processing (call technology support)",
    processing_payment: "Processing payment",
    payment_failed: "Payment failed",
    payment_success: "Payment successful",
    finished: "Processing and Charge Completed",
  },
};

export const CHARGING = {
  pt: "Carregando",
  es: "Cargando",
  en: "Charging",
};

export const FREE = {
  pt: "Grátis",
  es: "Gratis",
  en: "Free",
};

export const POS_PAYMENT = {
  pt: "Sem pagamento no app",
  es: "Sin pago en la app",
  en: "No payment in the app",
};

export const PAYMENT_METHOD = {
  pt: "Forma de pagamento",
  es: "Forma de pago",
  en: "Payment method",
};

export const CREDIT = {
  pt: "Crédito",
  es: "Crédito",
  en: "Credit",
};

export const BALANCE = {
  pt: "Saldo",
  es: "Saldo",
  en: "Balance",
};

export const KWH = (ENERGY) => ({
  pt: `${ENERGY} kWh`,
  es: `${ENERGY} kWh`,
  en: `${ENERGY} kWh`,
});

export const VALUE = {
  pt: "Valor total",
  es: "Valor total",
  en: "Amount",
};

export const STARTED_AT = {
  pt: "Inicio em",
  es: "Inicio en",
  en: "Started at",
};

export const ENDED_AT = {
  pt: "Término em",
  es: "Término en",
  en: "Ended at",
};

export const DURATION = {
  pt: "Duração carga",
  es: "Duración de la carga",
  en: "Charge duration",
};

export const IDLE_TIME = {
  pt: "Tempo ocioso",
  es: "Tiempo de inactividad",
  en: "Idle time",
};

export const STATION = {
  pt: "Estação",
  es: "Estación",
  en: "Station",
};

export const STATION_ID = {
  pt: "ID da estação",
  es: "ID de la estación",
  en: "Station ID",
};

export const CONNECTOR_ID = {
  pt: "ID do conector",
  es: "ID del conector",
  en: "Connector ID",
};

export const CHARGE_ID = {
  pt: "ID da carga",
  es: "ID de la carga",
  en: "Charge ID",
};

export const USER_ID = {
  pt: "ID do usuário",
  es: "ID del usuario",
  en: "User ID",
};

export const CREATED_AT = {
  pt: "Criado em",
  es: "Creado en",
  en: "Created At",
};

export const ENERGY_VALUE = {
  pt: "Valor energia",
  es: "Valor energético",
  en: "Energy value",
};

export const ACTIVATION_FEE_VALUE = {
  pt: "Taxa de ativação",
  es: "Tarifa de activación",
  en: "Activation fee",
};

export const IDLE_VALUE = {
  pt: "Ociosidade",
  es: "tarifa inactiva",
  en: "Idle fee",
};

export const COUPON = {
  pt: "Cupom",
  es: "Cupón",
  en: "Coupon",
};

export const CLOSE = {
  pt: "Fechar",
  es: "Cerrar",
  en: "Close",
};

export const LOADING_USER_CARS = {
  pt: "Buscando carros do usuário ...",
  es: "Buscando automóviles del usuario ...",
  en: "Searching users' cars ...",
};

export const ZIP_CODE = {
  pt: "CEP",
  es: "CPA",
  en: "Zip Code",
};

// TODO: address 1, address 2
export const PUBLIC_PLACE = {
  pt: "Logradouro",
  es: "Calle",
  en: "Public place",
};

export const NUMBER = {
  pt: "Número",
  es: "Número",
  en: "Number",
};

export const NEIGHBORHOOD = {
  pt: "Bairro",
  es: "Barrio",
  en: "Neighborhood",
};

export const COMPLEMENT = {
  pt: "Complemento",
  es: "Complemento",
  en: "Complement",
};

export const CITY = {
  pt: "Cidade",
  es: "Ciudad",
  en: "City",
};

export const STATE = {
  pt: "Estado",
  es: "Provincia",
  en: "State",
};

export const CITY_ID = {
  pt: "ID cidade",
  es: "ID ciudad",
  en: "City ID",
};

export const STATE_ID = {
  pt: "ID estado",
  es: "ID provincia",
  en: "State ID",
};

export const STATE_UF = {
  pt: "UF",
  es: "Código de provincia",
  en: "Federation Unit State",
};

export const COUNTRY_CODE = {
  pt: "Código do país",
  es: "Código del país",
  en: "Country code",
};

export const CURRENCY_CODE = {
  pt: "Código da moeda",
  es: "Código de la moneda",
  en: "Currency code",
};

export const NAME = {
  pt: "Nome",
  es: "Nombre",
  en: "Name",
};

export const FULL_NAME = {
  pt: "Nome completo",
  es: "Nombre completo",
  en: "Full name",
};

export const EMAIL = {
  pt: "Email",
  es: "Correo electrónico",
  en: "Email",
};

export const CHARGES = {
  pt: "Cargas",
  es: "Cargas",
  en: "Charges",
};

export const ACTIONS = {
  pt: "Ações",
  es: "Acciones",
  en: "Actions",
};

export const SEE_DETAILS = {
  pt: "Ver Detalhes",
  es: "Ver Detalles",
  en: "See Details",
};

export const SEE_CARS = {
  pt: "Ver Carros",
  es: "Ver automóviles",
  en: "See Cars",
};

export const TOTAL_CHARGES = {
  pt: "Total de cargas",
  es: "Cargas totales",
  en: "Total of charges",
};

export const OOPS = {
  pt: "Ops...",
  es: "Epa...",
  en: "Ops...",
};

export const MANAGEMENT = {
  pt: "Administração",
  es: "Administración",
  en: "Administration",
};

export const NEW = {
  pt: "Nova",
  es: "Nueva",
  en: "New",
};

export const EDIT_COMPANY = {
  pt: "Editar empresa",
  es: "Editar empresa",
  en: "Edit company",
};

export const PINS_CUSTOMIZED = {
  pt: "Pin customizado?",
  es: "¿Pin personalizado?",
  en: "Customized pin?",
};

export const AGO = (duration) => ({
  pt: `${duration} atrás`,
  es: `${duration} atrás`,
  en: `${duration} ago`,
});

export const AGE = {
  pt: "Idade",
  es: "Edad",
  en: "Age",
};

export const YEARS_OLD = (years) => ({
  pt: `${years} ano${years === 1 ? "" : "s"}`,
  es: `${years} año${years === 1 ? "" : "s"}`,
  en: `${years} year${years === 1 ? "" : "s"}`,
});

export const YES = {
  pt: "Sim",
  es: "Sí",
  en: "Yes",
};

export const NO = {
  pt: "Não",
  es: "No",
  en: "No",
};

export const SAVE = {
  pt: "Salvar",
  es: "Guardar",
  en: "Save",
};

export const CANCEL = {
  pt: "Cancelar",
  es: "Cancelar",
  en: "Cancel",
};

export const SHOW_DETAILS_EDIT = {
  pt: "Ver detalhes | Editar",
  es: "Ver detalles | Editar",
  en: "See details | Edit",
};

export const RECIPIENT = {
  pt: "Recebedor",
  es: "Receptor",
  en: "Recipient",
};

export const ALL_RIGHT = {
  pt: "Tudo certo!",
  es: "¡Está bien!",
  en: "All set!",
};

export const WEN_WONG = {
  pt: "Algo deu errado!",
  es: "¡Algo salió mal!",
  en: "Something went wrong!",
};

export const REQUIRED = {
  pt: "Campo obrigatório",
  es: "Campo obligatorio",
  en: "Mandatory field",
};

export const RECIPIENTS = {
  pt: "Recebedores",
  es: "Receptores",
  en: "Recipients",
};

export const SEARCH_BY_NAME = {
  pt: "Pesquise pelo nome...",
  es: "Busque por el nombre...",
  en: "Search by name...",
};

export const RECIPIENT_DATA = {
  pt: "Dados do recebedor",
  es: "Datos del receptor",
  en: "Recipient data",
};

export const BANK_DATA = {
  pt: "Dados bancários:",
  es: "Datos bancarios:",
  en: "Bank data:",
};

export const AGENCY = {
  pt: "Agencia",
  es: "Agencia",
  en: "Agency",
};

export const ACCOUNT = {
  pt: "Conta",
  es: "Cuenta",
  en: "Account",
};

export const BANK_CODE = {
  pt: "Código do banco",
  es: "Código del banco",
  en: "Bank code",
};

export const AGENCY_CHECK_DIGIT = {
  pt: "Dígito verificador da agência",
  es: "Dígito verificador de la agencia",
  en: "Agency verifier digit",
};

export const ACCOUNT_TYPE = {
  pt: "Tipo da conta",
  es: "Tipo de cuenta",
  en: "Account type",
};

export const ACCOUNT_VERIFICATION_DIGIT = {
  pt: "Dígito verificador da conta",
  es: "Dígito verificador de la cuenta",
  en: "Account verifier digit",
};

export const FULL_NAME_BUSINESS_NAME = {
  pt: "Nome completo ou razão social",
  es: "Nombre completo o razón social",
  en: "Complete name or corporate name",
};

export const ACCOUNT_CPF_OR_CNPJ = {
  pt: "CPF ou CNPJ da conta",
  es: "DNI o CUIT de la cuenta",
  en: "Account CPF or CNPJ",
};

export const SHOW_DETAILS = {
  pt: "Ver detalhes",
  es: "Ver detalles",
  en: "See details",
};

export const COUPON_USE = {
  pt: "Utilização",
  es: "Usar",
  en: "Use",
};

export const COUPON_DATA = {
  pt: "Dados do cupom",
  es: "Detalles del cupón",
  en: "Coupon details",
};

export const RECIPIENT_ADD_SUCCESS = {
  pt: "Recebedor adicionado com sucesso!",
  es: "¡Receptor añadido con éxito!",
  en: "Successfully added recipient!",
};

export const DATA_OF_RECEIPT = {
  pt: "Dados para recebimento",
  es: "Datos para la recepción",
  en: "Receipt data",
};

export const RECEIVER_NAME = {
  pt: "Nome do recebedor",
  es: "Nombre del destinatario",
  en: "Recipient name",
};

export const ANTICIPABLE_DESCRIPTION = {
  pt: "Essa propriedade define a porcentagem referente ao valor a receber que o recebedor pode antecipar junto ao Pagar.me. Por padrão, novos recebedores possuem essa propriedade com valor 0.",
  es: "Esta propiedad define el porcentaje referente al valor a recibir y que el destinatario puede anticipar junto a Pagar.me. Por defecto, los nuevos destinatarios tienen esta propiedad con valor 0.",
  en: "This property defines the percentage referring to the amount receivable that the recipient can anticipate with Pagar.me. By default, new recipients have this property set to 0.",
};

export const AUTOMATIC_ANTICIPATION_DESCRIPTION = {
  pt: "Define se o recebedor pode receber antecipações automáticas.",
  es: "Define si el destinatario puede recibir anticipos automáticos.",
  en: "Defines whether the recipient can receive automatic prepayments.",
};

export const TRANSFER_DAY_DESCRIPTION = {
  pt: "Essa propriedade define em qual dia as transferências automáticas são feitas para o recebedor, dado o transfer_interval escolhido. Os valores possíveis são: 1 a 5 se transfer_interval for igual a weekly. 1 a 31 se transfer_interval for igual a monthly. 0 se transfer_interval for igual daily.",
  es: "Esta propiedad define en qué día se realizan las transferencias automáticas al destinatario, dado el transfer_interval elegido. Los valores posibles son: 1 a 5 si el intervalo de transferencia es semanal. 1 a 31 si el intervalo de transferencia es mensual. 0 si el intervalo de transferencia es diario.",
  en: "This property defines on which day automatic transfers are made to the recipient, given the chosen transfer_interval. Possible values ​​are: 1 to 5 if transfer_interval equals weekly. 1 to 31 if transfer_interval equals monthly. 0 if transfer_interval equals daily.",
};

export const TRANSFER_ENABLED = {
  pt: "Essa propriedade define se o recebedor pode receber seus pagamentos automaticamente, no dia e no intervalo que forem definidos.",
  es: "Esta propiedad define si el detinatario puede recibir sus pagos automáticamente, el día y el intervalo que se establecen.",
  en: "This property defines whether the recipient can receive his payments automatically, on the day and at the interval that is defined.",
};

export const ACCOUNT_NUMBER = {
  pt: "Número da conta",
  es: "Número de cuenta",
  en: "Account number",
};

export const CHECKING_ACCOUNT = {
  pt: "Conta corrente",
  es: "Cuenta corriente",
  en: "Current account",
};

export const SAVING_ACCOUNT = {
  pt: "Conta poupança",
  es: "Cuenta de ahorro",
  en: "Savings account",
};

export const JOINT_CHECKING_ACCOUNT = {
  pt: "Conta corrente conjunta",
  es: "Cuenta corriente conjunta",
  en: "Joint current account",
};

export const JOINT_SAVING_ACCOUNT = {
  pt: "Conta poupança conjunta",
  es: "Cuenta de ahorro conjunta",
  en: "Joint savings account",
};

export const ERROR_EDIT_USER = {
  pt: "Erro ao editar o usuário",
  es: "Error al editar el usuario",
  en: "Error editing the user",
};

export const VERIFY_DATA_TRY_AGAIN = {
  pt: "Verifique as informações e tente novamente",
  es: "Compruebe las informaciones e inténtelo nuevamente",
  en: "Check the information's and try again",
};

export const GET_GROUP_PERMISSION_USERS = {
  pt: "Erro ao buscar o grupo de permissão do usuário",
};
export const REQUIRED_FIELD = {
  pt: "Campo obrigatório",
  es: "Campo obligatorio",
  en: "Mandatory field",
};

export const SELECT_COMPANY = {
  pt: "Selecione a empresa",
  en: "Select the company",
  es: "Seleccione la empresa",
};

export const SELECT_GROUP = {
  pt: "Selecione o grupo",
  en: "Select the group",
  es: "Seleccione el grupo",
};

export const LOADING = {
  pt: "Carregando...",
  es: "Cargando...",
  en: "Loading...",
};

export const USER_CARS = {
  pt: "Carros do usuário",
  es: "Automóviles del usuario",
  en: "User cars",
};

export const COMPANY = {
  pt: "Empresa",
  es: "Empresa",
  en: "Company",
};

export const CAMPAIGN = {
  pt: "Campanha",
  es: "Campaña",
  en: "Campaign",
};

export const DISCOUNT = {
  pt: "Desconto",
  en: "Discount",
  es: "Descuento",
};

export const PARENT_COMPANY = {
  pt: "Empresa mãe",
  es: "Empresa madre",
  en: "Parent company",
};

export const SELECT_PARENT_COMPANY = {
  pt: "Selecione a empresa mãe",
  es: "Seleccione la empresa madre",
  en: "Select the parent company",
};

export const URL_POWERBI = {
  pt: "Url PowerBI",
};

export const WHITE_LABEL = {
  pt: "White Label",
};

export const SELECT_RECIPIENT = {
  pt: "Selecione um recebedor",
  es: "Seleccione un destinatario",
  en: "Select a recipient",
};

export const PAY_CHARGE_SUCCESS = {
  pt: "Pagamento efetuado com sucesso!",
  es: "Pago realizado con exito!",
  en: "Payment done successfully!",
};

export const PAY_CHARGE_ERROR = {
  pt: "Não foi possível efetuar o pagamento!",
  es: "No se pudo realizar el pago!",
  en: "Could not make the payment!",
};

export const CONFIRM_PAY_CHARGE = {
  pt: "Deseja realmente reprocessar o pagamento?",
  es: "¿Desea realmente reprocesar el pago?",
  en: "Do you really want to reprocess the payment?",
};

export const PAY_CHARGE = {
  pt: "Reprocessar o pagamento",
  es: "Reprocesar el pago",
  en: "Do you really want to reprocess the payment?",
};

export const ACCESS_GROUP_PERMISSIONS = {
  pt: "Grupo de permissões de acesso",
  es: "Grupo de permisos de acceso",
  en: "Access group permissions",
};

export const PERMISSION_GUIDE = {
  pt: "Guia de permissões",
  es: "Guía de permisos",
  en: "Permission guide",
};

export const NOT_AVAILABLE_GROUP = {
  pt: "Grupo indisponível",
  es: "Grupo no disponible",
  en: "Group not available",
};

export const EDIT_USER = {
  pt: "Editar usuário",
  es: "Editar usuario",
  en: "Edit user",
};

export const ERROR_GET_DETAILS_USER = {
  pt: "Erro ao buscar as informações do usuário",
  es: "Error al buscar los detalles del usuario",
  en: "Error getting user details",
};

export const ERROR_GET_DETAILS_COUPON = {
  pt: "Erro ao buscar as informações do cupom",
  es: "Error al buscar los detalles del cupón",
  en: "Error getting coupon details",
};

export const ANTIFRAUD_CHECK_CHANGED = (status) => ({
  pt: `Verificação antifraude ${
    status ? "ativada" : "desativada"
  } para esse usuário`,
});

export const ANTIFRAUD_CHECK_CHANGED_ERROR = {
  pt: "Erro ao alterar verificação antifraude para esse usuário",
  es: "Error al cambiar la verificación antifraude para este usuario",
  en: "Error changing antifraud check for this user",
};

export const USER_STATUS_CHANGED = {
  pt: "Status do usuário alterado com sucesso!",
  es: "Estado del usuario cambiado con éxito!",
  en: "User status changed successfully!",
};

export const USER_STATUS_CHANGE_ERROR = {
  pt: "Erro ao alterar status do usuário",
  es: "Error al cambiar el estado del usuario",
  en: "Error changing user status",
};

export const PERSONAL_DATA = {
  pt: "Dados pessoais",
  es: "Datos personal",
  en: "Personal data",
};

export const ASSOCIATECUPONS_DATA = {
  pt: "Cupons vinculados",
  es: "Cupóns vinculados",
  en: "Coupons linked",
};

export const LOADING_USER_DETAILS = {
  pt: "Buscando as informações do usuário ...",
  es: "Buscando detalles del usuario ...",
  en: "Loading user details ...",
};

export const LOADING_CUPON_DETAILS = {
  pt: "Buscando as informações dos cupons vinculados ...",
  es: "Buscando detalles de los cupóns vinculados ...",
  en: "Loading coupon details ...",
};

export const DOCUMENT = {
  pt: "CPF",
  es: "CIF",
  en: "ID",
};

export const VALIDATE_DOCUMENT = {
  pt: "Validar documento",
  es: "Validar documento",
  en: "Validate document",
};

export const RAW = {
  pt: "raw",
  es: "raw",
  en: "raw",
};

export const BIRTHDATE = {
  pt: "Data de nascimento",
  es: "Fecha de nacimiento",
  en: "Birthdate",
};

export const PHONE = {
  pt: "Telefone",
  es: "Teléfono",
  en: "Phone",
};

export const ADDRESS = {
  pt: "Endereço",
  es: "Dirección",
  en: "Address",
};

export const USER_ANTIFRAUD_CHECK = {
  pt: "Verificação antifraude ativada para este usuário",
  es: "Verificación antifraude activada para este usuario",
  en: "Antifraud check activated for this user",
};

export const PAID = {
  pt: "Paga",
  es: "Paga",
  en: "Paid",
};

export const NOT_PAID = {
  pt: "Não paga",
  es: "No paga",
  en: "Not paid",
};

export const INVALID = {
  pt: "Inválido",
  en: "Invalid",
  es: "Inválido",
};

// TODO: exportar textos de data de nascimento e forma de pagamento
export const INVALID_FEMALE = {
  pt: "Inválida",
  en: "Invalid",
  es: "Inválida",
};

export const CHARGES_COUNT = (count) => ({
  pt: `${count > 0 ? `${count} ` : ""}Carga${count === 1 ? "" : "s"}`,
  es: `${count > 0 ? `${count} ` : ""}Carga${count === 1 ? "" : "s"}`,
  en: `${count > 0 ? `${count} ` : ""}Charge${count === 1 ? "" : "s"}`,
});

export const USER_EMPTY_CHARGES = {
  pt: "O usuário ainda não fez nenhuma carga.",
  es: "El usuario todavía no ha realizado ninguna carga.",
  en: "The user has not yet made any charge.",
};

export const SEE_ON_OCPP = (transactionID) => ({
  pt: `Ver no OCPP (ID: ${transactionID})`,
  es: `Ver en el OCPP (ID: ${transactionID})`,
  en: `See on OCPP (ID: ${transactionID})`,
});

export const REFUND_IDLE_FEE = {
  pt: `Estornar ociosidade`,
  es: `Reembolsar inactividad`,
  en: `Refund idleness`,
};

export const REFUND_ACTIVATION_FEE = {
  pt: `Estornar taxa de ativação`,
  es: `Reembolsar tasa de activación`,
  en: `Refund activation fee`,
};

export const RFID_TAG = {
  pt: "Tag RFID",
  es: "Etiqueta RFID",
  en: "RFID Tag",
};

export const APP = {
  pt: "Aplicativo",
  es: "Aplicación",
  en: "App",
};

export const APPS = {
  pt: "Aplicativos",
  es: "Aplicacións",
  en: "Apps",
};

export const COPY = {
  pt: "Copiar",
  es: "Copiar",
  en: "Copy",
};

export const COPIED = {
  pt: "Copiado com sucesso!",
  es: "¡Copiado con éxito!",
  en: "Copied successfully!",
};

export const USER_EMPTY_COUPONS = {
  pt: "Nenhum cupom vinculado",
  es: "Ningun cupón vinculado",
  en: "No coupon linked",
};

export const COUPON_CODE = {
  pt: "Verificar",
  es: "Verificar",
  en: "To check",
};

export const COUPON_INFO = {
  pt: "Dados do Cupom",
  es: "Información del cupón",
  en: "Coupon info",
};

export const COUPON_USAGE = {
  pt: "Utilização",
  es: "Utilización",
  en: "Usage",
};

export const EXPIRED = {
  pt: "Expirado",
  es: "Venció",
  en: "Expired",
};

export const VERIFIED = {
  pt: "Verificado",
  es: "Verificado",
  en: "Verified",
};

export const NOT_VERIFIED = {
  pt: "Não verificado",
  es: "No verificado",
  en: "Not verified",
};

export const IN_USE = {
  pt: "Em uso",
  es: "En uso",
  en: "In use",
};

export const INACTIVE = {
  pt: "Inativo",
  es: "Inactivo",
  en: "Inactive",
};

export const EXPIRATION = {
  pt: "Expiração",
  es: "Vencimiento",
  en: "Expiration",
};

export const COUPON_STATUS = {
  pt: "Status",
  es: "Estado",
  en: "Status",
};

export const USER_STATUS = {
  pt: "Status",
  es: "Estado",
  en: "Status",
};

export const CHANGE_USER_STATUS = {
  pt: "Alterar status",
  es: "Cambiar estado",
  en: "Change status",
};

export const STATUS_REASON_PLACEHOLDER = {
  pt: "Motivo do novo status",
  es: "Motivo del nuevo estado",
  en: "Reason for new status",
};

export const SAVE_NEW_STATUS = {
  pt: "Salvar novo status",
  es: "Guardar nuevo estado",
  en: "Save new status",
};

export const NO_STATUS_TRANSITION_AVAILABLE = {
  pt: "Nenhuma transição permitida a partir do status atual",
  es: "No hay transiciones permitidas desde el estado actual",
  en: "No transition allowed from the current status",
};

export const STATUS_OPTIONS_LOAD_ERROR = {
  pt: "Não foi possível carregar os status disponíveis",
  es: "No se pudieron cargar los estados disponibles",
  en: "Could not load the available statuses",
};

export const NO_STATUS_OPTION_TO_PICK = {
  pt: "Nenhum status para escolher",
  es: "Ningún estado para elegir",
  en: "No status to pick",
};

export const RETRY_LOADING_STATUS_OPTIONS = {
  pt: "Tentar de novo",
  es: "Intentar de nuevo",
  en: "Try again",
};

export const FORCE_STATUS_LABEL = {
  pt: "Forçar status (dev)",
  es: "Forzar estado (dev)",
  en: "Force status (dev)",
};

export const FORCE_STATUS_REASON_REQUIRED = {
  pt: "Informe um motivo de pelo menos 5 caracteres para forçar o status",
  es: "Indique un motivo de al menos 5 caracteres para forzar el estado",
  en: "Enter a reason of at least 5 characters to force the status",
};

export const FORCE_STATUS_CONFIRM = {
  pt: "Forçar status ignora todas as regras de transição. Confirma?",
  es: "Forzar el estado ignora todas las reglas de transición. ¿Confirma?",
  en: "Forcing the status skips every transition rule. Confirm?",
};

export const USER_STATUS_ERROR_BY_CODE = {
  pt: {
    no_permission: "Seu perfil não pode alterar o status de usuários.",
    target_not_allowed_for_tier: "Seu perfil não pode definir esse status.",
    transition_not_allowed:
      "Essa mudança de status não é permitida a partir do status atual.",
    force_requires_developer: "Só desenvolvedor Tupi pode forçar um status.",
    quarantined_requires_antifraud_analysis:
      "Tirar uma conta da quarentena exige análise do antifraude.",
  },
  es: {
    no_permission: "Su perfil no puede cambiar el estado de usuarios.",
    target_not_allowed_for_tier: "Su perfil no puede definir ese estado.",
    transition_not_allowed:
      "Ese cambio de estado no está permitido desde el estado actual.",
    force_requires_developer: "Solo un desarrollador Tupi puede forzar un estado.",
    quarantined_requires_antifraud_analysis:
      "Sacar una cuenta de la cuarentena exige análisis del antifraude.",
  },
  en: {
    no_permission: "Your profile cannot change user status.",
    target_not_allowed_for_tier: "Your profile cannot set that status.",
    transition_not_allowed:
      "That status change is not allowed from the current status.",
    force_requires_developer: "Only a Tupi developer may force a status.",
    quarantined_requires_antifraud_analysis:
      "Taking an account out of quarantine requires antifraud analysis.",
  },
};

export const USER_STATUS_DESCRIPTION = {
  pt: {
    newly_created: "Acabou de ser criado",
    draft: "Em preenchimento",
    pending_validation: "Aguardando aprovação",
    pending_birth_date_review: "Aguardando revisão da data de nascimento",
    validated_with_divergences: "Validado com divergências",
    approved: "Aprovado",
    rejected: "Rejeitado",
    suspended: "Suspenso",
    cleared: "Liberado após validação",
    quarantined: "Em quarentena (suspenso, sob análise de fraude)",
    blocked: "Bloqueado",
    trusted: "Confiável",
    foreign_user: "Usuário estrangeiro",
  },

  es: {
    newly_created: "Recién creado",
    draft: "Borrador",
    pending_validation: "Esperando aprobación",
    pending_birth_date_review: "Esperando revisión de la fecha de nacimiento",
    validated_with_divergences: "Validado con divergencias",
    approved: "Aprobado",
    rejected: "Rechazado",
    suspended: "Suspendido",
    cleared: "Liberado tras la validación",
    quarantined: "En cuarentena (suspendido, bajo análisis de fraude)",
    blocked: "Bloqueado",
    trusted: "Confiable",
    foreign_user: "Usuario extranjero",
  },
  en: {
    newly_created: "Newly created",
    draft: "Draft",
    pending_validation: "Pending validation",
    pending_birth_date_review: "Pending birth date review",
    validated_with_divergences: "Validated with divergences",
    approved: "Approved",
    rejected: "Rejected",
    suspended: "Suspended",
    cleared: "Cleared after validation",
    quarantined: "Quarantined (suspended, under fraud review)",
    blocked: "Blocked",
    trusted: "Trusted",
    foreign_user: "Foreign user",
  },
};

export const USER_STATUS_REASON = {
  pt: "Motivo do status",
  es: "Motivo del estado",
  en: "Reason for status",
};

export const COUPON_ACTIONS = {
  pt: "Ação",
  es: "Acción",
  en: "Action",
};

export const COUPON_UNLINK = {
  pt: "Desvincular cupom",
  es: "Desvincular cupón",
  en: "Unlink coupon",
};

export const UNLINK = {
  pt: "Desvincular",
  es: "Desvincular",
  en: "Unlink",
};
export const LINK = {
  pt: "Vincular",
  es: "Vincular",
  en: "Link",
};

export const LINKED = {
  pt: "Vinculada",
  es: "Vinculada",
  en: "Linked",
};

export const LANGUAGE = {
  pt: "Idioma",
  // TODO: es
  // TODO: en
};

export const ARE_YOU_SURE_UNLINK_COUPON = {
  pt: "Você tem certeza que deseja desvincular este cupom do usuário?",
  es: "Está seguro que desea desvincular este cupón de este usuario?",
  en: "Are you sure you want to unlink this coupon from this user?",
};

export const COUPON_UNLINK_SUCCESS = {
  pt: "O cupom foi desvinculado do usuário",
  es: "El cupón fue desvinculado del usuario",
  en: "The coupon was unlinked from the user",
};

export const OK_COUPON = {
  pt: "Tudo certo!",
  es: "¡Todo salió bien!",
  en: "All good!",
};

export const ERROR_UNLINK_COUPON = {
  pt: "Erro ao desvincular o cupom!",
  es: "¡Error al desvincular el cupón!",
  en: "Error to unlink coupon!",
};

export const IS_PERSON_FRAUDSTER = {
  pt: "Checagem Anti Fraude",
  es: "Verificación Antifraude",
  en: "Antifraud Check",
};

export const EMAIL_DOMAIN_STATUS = {
  pt: {
    valid: "Válido",
    invalid: "Inválido",
    blocked: "Bloqueado",
    pending: "Pendente",
  },
  es: {
    valid: "Válido",
    invalid: "Inválido",
    blocked: "Bloqueado",
    pending: "Pendiente",
  },
  en: {
    valid: "Valid",
    invalid: "Invalid",
    blocked: "Blocked",
    pending: "Pending",
  },
};

export const TAGS_TITLE = {
  pt: "Tags",
  es: "Tags",
  en: "Tags",
};

export const TAGS_LOADING = {
  pt: "Buscando as informações das tags vinculadas ...",
  es: "Buscando detalles de las tags vinculadas ...",
  en: "Loading tags details ...",
};

export const USER_EMPTY_TAGS = {
  pt: "Nenhuma tag vinculada",
  es: "Ninguna tag vinculada",
  en: "No tag linked",
};

export const TAGS_COLUMN_ACTIVE = {
  pt: "Ativa",
  es: "Activa",
  en: "Active",
};

export const TAGS_COLUMN_COD = {
  pt: "Dados da tag",
  es: "Datos de la tag",
  en: "Tag data",
};

export const TAGS_COLUMN_QUANTITY = {
  pt: "Qtd. usada",
  es: "Quant. usada",
  en: "Qty. used",
};

export const TAGS_COLUMN_LAST_USAGE = {
  pt: "Último uso",
  es: "Ultimo uso",
  en: "Last usage",
};

export const TAGS_COLUMN_ACTION = {
  pt: "Ação",
  es: "Acción",
  en: "Action",
};

export const TAG_UNLINK = {
  pt: "Desvincular tag",
  es: "Desvincular tag",
  en: "Unlink tag",
};

export const TAG_LINK = {
  pt: "Vincular tag",
  es: "Vincular tag",
  en: "Link tag",
};

export const ADD_TAG = {
  pt: "Adicionar tag",
  es: "Agregar tag",
  en: "Add tag",
};

export const ERROR_GET_TAG_DETAILS = {
  pt: "Erro ao buscar as informações das tags",
  es: "Error al buscar los detalles de las tags",
  en: "Error getting tags details",
};

export const ERROR_GET_STATIONS = {
  pt: "Erro ao buscar as informações das estações",
  es: "Error al buscar los detalles de las estaciones",
  en: "Error getting stations details",
};

export const ERROR_GET_TOKENS = {
  pt: "Erro ao buscar as tags!",
  es: "Error al buscar las tags!",
  en: "Error getting tags!",
};

export const SELECT_STATION = {
  pt: "Selecione a estação",
  es: "Seleccione la estación",
  en: "Select station",
};

export const BY_STATION = {
  pt: "Por estação",
  es: "Por estación",
  en: "By station",
};

export const BY_CODE = {
  pt: "Por código",
  es: "Por codigo",
  en: "By code",
};

export const TAGS_LOGS_COLUMN_COD = {
  pt: "Código",
  es: "Codigo",
  en: "Code",
};

export const TAGS_LOGS_COLUMN_DATE = {
  pt: "Data e hora",
  es: "Fecha y hora",
  en: "Date and time",
};

export const TAGS_INSERT_COD = {
  pt: "Inserir código",
  es: "Ingresar codigo",
  en: "Insert code",
};

export const LINK_TAG_PART = {
  pt: `Vincular a tag `,
  es: `Vincular la tag `,
  en: `Link tag `,
};

export const TO_USER = (email) => ({
  pt: `ao usuário ${email}?`,
  es: `al usuario ${email}?`,
  en: `to user ${email}?`,
});

export const TAG_LINK_SUCCESS = {
  pt: `Tag vinculada com sucesso!`,
  es: `Tag vinculada con exito!`,
  en: `Tag linked successfully!`,
};

export const TAG_UNLINK_SUCCESS = {
  pt: `Tag desvinculada com sucesso!`,
  es: `Tag desvinculada con exito!`,
  en: `Tag unlinked successfully!`,
};

export const TAG_UPDATED_ON = {
  pt: `Atualizado em`,
  es: `Actualizado en`,
  en: `Updated on`,
};

export const TAG_REFRESH_NOW = {
  pt: `Atualizar agora`,
  es: `Actualizar ahora`,
  en: `Refresh now`,
};

export const TAG_AT = {
  pt: `às`,
  es: `a las`,
  en: `at`,
};

export const ARE_YOU_SURE_UNLINK_TAG = {
  pt: "Você tem certeza que deseja desvincular esta tag deste usuário?",
  es: "¿Seguro que desea desvincular esta tag de este usuario?",
  en: "Are you sure you want to unlink this tag from this user?",
};

export const SEE_RECEIPT = {
  pt: "Ver/Baixar recibo",
  es: "Ver/Descargar recibo",
  en: "See/Download receipt",
};

export const TRANSFER_BALANCE_CONFIRM = (email) => ({
  pt: `Transferir saldo do usuário ${email} para o usuário atual?`,
  es: `¿Transferir el saldo del usuario ${email} al usuario actual?`,
  en: `Transfer balance from user ${email} to the current user?`,
});

export const TRANSFER_BALANCE_CONFIRM_NO_EMAIL = {
  pt: "Transferir saldo negativo de outras contas para a conta atual?",
  es: "¿Transferir el saldo negativo de otras cuentas a la cuenta actual?",
  en: "Transfer negative balance from other accounts to the current account?",
};

export const TRANSFER_BALANCE_SUCCESS = {
  pt: "Transferência realizada com sucesso.",
  es: "Transferencia realizada con éxito.",
  en: "Transfer completed successfully.",
};

export const TRANSFER_BALANCE_ERROR = {
  pt: "Erro ao transferir saldo.",
  es: "Error al transferir saldo.",
  en: "Error transferring balance.",
};

export const PENDING_BALANCE_IN_OTHER_ACCOUNTS = {
  pt: "Saldo em outras contas:",
  es: "Saldo en otras cuentas:",
  en: "Balance in other accounts:",
};

export const TYPE = {
  pt: "Tipo",
  es: "Tipo",
  en: "Type",
};

export const STATUS = {
  pt: "Status",
  es: "Estado",
  en: "Status",
};

export const BALANCE_BEFORE = {
  pt: "Saldo Antes",
  es: "Saldo Antes",
  en: "Balance Before",
};

export const BALANCE_AFTER = {
  pt: "Saldo Depois",
  es: "Saldo Después",
  en: "Balance After",
};

export const TRANSACTION_VALUE = {
  pt: "Valor",
  es: "Valor",
  en: "Value",
};

export const REFUNDED_VALUE = {
  pt: "Valor estornado",
  es: "Valor reembolsado",
  en: "Refunded Value",
};

export const WAITING_REFUND = {
  pt: "Aguardando estorno",
  es: "Aguardando reembolso",
  en: "Waiting for refund",
};

export const REFUND = {
  pt: "Estornar",
  es: "Reembolsar",
  en: "Refund",
};

export const DOWNLOAD_REFUND_RECEIPT = {
  pt: "Baixar comprovante de estorno",
  es: "Descargar recibo de reembolso",
  en: "Download refund receipt",
};

export const ERROR_DOWNLOAD_REFUND_RECEIPT = {
  pt: "Não foi possível baixar o comprovante de estorno",
  es: "No se pudo descargar el recibo de reembolso",
  en: "Could not download the refund receipt",
};

export const ERROR_REQUEST_REFUND = {
  pt: "Não foi possível solicitar o estorno",
  es: "No fue posible solicitar el reembolso",
  en: "Could not request the refund",
};

export const WALLETS = {
  pt: "Carteiras",
  es: "Carteras",
  en: "Wallets",
};

export const WALLET = {
  pt: "Carteira",
  es: "Cartera",
  en: "Wallet",
};

export const NOTIFICATIONS_ENABLED = {
  pt: "Notificações habilitadas",
  es: "Notificaciones habilitadas",
  en: "Notifications enabled",
};

export const EMAIL_VERIFIED = {
  pt: "E-mail verificado",
  es: "Correo verificado",
  en: "Email verified",
};

export const COPY_STRIPE_PAYMENT_LINK = {
  pt: "Copiar link Stripe",
  es: "Copiar enlace Stripe",
  en: "Copy Stripe link",
};

export const STRIPE_PAYMENT_LINK_COPIED = {
  pt: "Link de pagamento copiado.",
  es: "Enlace de pago copiado.",
  en: "Payment link copied.",
};

export const STRIPE_PAYMENT_LINK_COPY_ERROR = {
  pt: "Não foi possível copiar o link de pagamento.",
  es: "No se pudo copiar el enlace de pago.",
  en: "Could not copy the payment link.",
};

export const STRIPE_PAYMENT_LINK_EMAIL_MISSING = {
  pt: "O usuário não possui um email disponível.",
  es: "El usuario no tiene un correo electrónico disponible.",
  en: "User does not have an available email.",
};

export const PAYMENTS = {
  pt: "Pagamentos",
  es: "Pagos",
  en: "Payments",
};

export const UPDATE_BALANCE_CONFIRM = {
  pt: "Tem certeza que deseja atualizar o saldo dessa carteira?",
  es: "¿Está seguro de que desea actualizar el saldo de esta cartera?",
  en: "Are you sure you want to update the balance of this wallet?",
};

export const COUNTRY = {
  pt: "País",
  es: "País",
  en: "Country",
};

export const CURRENCY = {
  pt: "Moeda",
  es: "Moneda",
  en: "Currency",
};

export const OLD_BALANCE = {
  pt: "Saldo antigo",
  es: "Saldo anterior",
  en: "Old Balance",
};

export const NEW_BALANCE = {
  pt: "Novo saldo",
  es: "Nuevo saldo",
  en: "New Balance",
};

export const FULL_REFUND = {
  pt: "Reembolso total",
  es: "Reembolso total",
  en: "Full refund",
};

export const PARTIAL_REFUND = {
  pt: "Reembolso parcial",
  es: "Reembolso parcial",
  en: "Partial refund",
};

export const PARTIAL_REFUND_SUCCESS = {
  pt: "Estorno parcial realizado",
  es: "Reembolso parcial realizado",
  en: "Partial refund processed",
};

export const PARTIAL_REFUND_FALLBACK = {
  pt: "Não foi possível estornar o valor total. Foram estornados",
  es: "No fue posible reembolsar el total. Se reembolsaron",
  en: "Could not refund the full amount. Partially refunded",
};

export const REFUND_VALUE = {
  pt: "Valor do reembolso",
  es: "Valor del reembolso",
  en: "Refund value",
};

export const REFUND_DB_WEBHOOK_WARNING = {
  pt: "O banco de dados será atualizado pelo webhook do gateway, então pode levar algum tempo.",
  es: "La base de datos se actualizará por el webhook del gateway, por lo que puede tardar un poco.",
  en: "The database will be updated by the gateway webhook, so it may take some time.",
};

export const REFUND_FULL_CONFIRM = {
  pt: "Tem certeza que deseja reembolsar o valor total?",
  es: "¿Está seguro de que desea reembolsar el valor total?",
  en: "Are you sure you want to refund the full value?",
};

export const REFUND_CONFIRM = {
  pt: "Tem certeza que deseja reembolsar?",
  es: "¿Está seguro de que desea reembolsar?",
  en: "Are you sure you want to refund?",
};

export const REFUND_IDLENESS_CONFIRM = {
  pt: "Confirma o estorno da ociosidade?",
  es: "¿Está seguro de que desea reembolsar la inactividad?",
  en: "Are you sure you want to refund the idle fee?",
};

export const REFUND_ACTIVATION_CONFIRM = {
  pt: "Confirma o estorno da taxa de ativação?",
  es: "¿Confirma el reembolso de la tasa de activación?",
  en: "Are you sure you want to refund the activation fee?",
};

export const REFUND_REASON_PLACEHOLDER = {
  pt: "Motivo do estorno (obrigatório)",
  es: "Motivo del reembolso (obligatorio)",
  en: "Refund reason (required)",
};

export const REFUND_REASON = {
  pt: "Motivo do estorno",
  es: "Motivo del reembolso",
  en: "Refund reason",
};

export const REFUND_AUTHOR = {
  pt: "Autor do estorno",
  es: "Autor del reembolso",
  en: "Author reason",
};

export const REFUND_CONFIRM_BTN = {
  pt: "Confirmar estorno",
  es: "Confirmar reembolso",
  en: "Confirm refund",
};

export const REFUND_REASON_REQUIRED = {
  pt: "Motivo do estorno é obrigatório (mínimo 3 caracteres)",
  es: "El motivo del reembolso es obligatorio (mínimo 3 caracteres)",
  en: "Refund reason is mandatory (minimum 3 characters)",
};

export const ATTENTION = {
  pt: "Atenção",
  es: "Atención",
  en: "Attention",
};

export const OLD_VALUE = {
  pt: "Valor antigo",
  es: "Valor anterior",
  en: "Old value",
};

export const WILL_REMAIN = {
  pt: "Vai restar",
  es: "Quedará",
  en: "Will remain",
};

export const BALANCE_UPDATE_SUCCESS = {
  pt: "Saldo atualizado com sucesso.",
  es: "Saldo actualizado con éxito.",
  en: "Balance updated successfully.",
};

export const BALANCE_UPDATE_ERROR = {
  pt: "Falha ao atualizar o saldo.",
  es: "Error al actualizar el saldo.",
  en: "Failed to update balance.",
};

export const SETTLE_NEGATIVE_BALANCE = {
  pt: "Quitar saldo negativo",
  es: "Liquidar saldo negativo",
  en: "Settle negative balance",
};

export const SETTLE_NEGATIVE_BALANCE_CONFIRM = {
  pt: "Deseja solicitar a quitação do saldo negativo desta carteira?",
  es: "¿Desea solicitar la liquidación del saldo negativo de esta cartera?",
  en: "Do you want to settle this wallet's negative balance?",
};

export const SETTLE_NEGATIVE_BALANCE_SUCCESS = {
  pt: "Solicitação de quitação enviada com sucesso.",
  es: "Solicitud de liquidación enviada con éxito.",
  en: "Settlement request sent successfully.",
};

export const SETTLE_NEGATIVE_BALANCE_ERROR = {
  pt: "Falha ao solicitar a quitação do saldo negativo.",
  es: "Error al solicitar la liquidación del saldo negativo.",
  en: "Failed to settle the negative balance.",
};

export const SETTLE_NEGATIVE_BALANCE_METHOD_INFO = {
  pt: "A quitação usará o método de pagamento primário do usuário.",
  es: "La liquidación usará el método de pago principal del usuario.",
  en: "This will charge the user's primary payment method.",
};

export const SETTLE_NEGATIVE_BALANCE_METHOD_UNKNOWN = {
  pt: "Método de pagamento primário indisponível",
  es: "Método de pago principal no disponible",
  en: "Primary payment method unavailable",
};

export const SETTLE_NEGATIVE_BALANCE_PRIMARY_IS_WALLET = {
  pt: "Não é possível quitar o débito porque o método de pagamento primário do usuário é uma carteira.",
  es: "No es posible liquidar la deuda porque el método de pago principal del usuario es una wallet.",
  en: "Cannot settle the debt because the user's primary payment method is a wallet.",
};

export const SETTLE_NEGATIVE_BALANCE_PRIMARY_INCOMPATIBLE = {
  pt: "Não é possível quitar o débito porque o método de pagamento primário usa outro país ou moeda.",
  es: "No es posible liquidar la deuda porque el método de pago principal usa otro país o moneda.",
  en: "Cannot settle because the primary payment method uses a different country or currency.",
};

export const NO_WALLETS_FOUND = {
  pt: "Nenhuma carteira encontrada.",
  es: "No se encontraron carteras.",
  en: "No wallets found.",
};

export const ORDERS = {
  pt: "Ordens",
  es: "Ordens",
  en: "Orders",
};

export const LOADING_ORDERS = {
  pt: "Carregando ordens...",
  es: "Cargando ordens...",
  en: "Loading orders...",
};

export const ERROR_GET_ORDERS = {
  pt: "Erro ao buscar ordens",
  es: "Error al buscar ordens",
  en: "Error loading orders",
};

export const CHARGING_MODE = {
  pt: "Modo de carga",
  es: "Modo de carga",
  en: "Charging mode",
};

export const CHARGING_LIMIT = {
  pt: "Limite da carga",
  es: "Limite da carga",
  en: "Charging limit",
};

export const USER_CHARGING_MODE_DESCRIPTION = {
  pt: {
    LIMITED: "Carga com limite",
    UNLIMITED: "Carga sem limite",
  },
  es: {
    LIMITED: "Carga con limite",
    UNLIMITED: "Carga sin limite",
  },
  en: {
    LIMITED: "Charging with limit",
    UNLIMITED: "Charging without limit",
  },
};

export const CHARGE_LIMITED_TO = (value) => ({
  pt: `Limitada a ${value}`,
  es: `Limitada a ${value}`,
  en: `Limited to ${value}`,
});

export const CHARGING_MODE_UNLIMITED = {
  pt: "Sem limite",
  es: "Sin limite",
  en: "Without limit",
};

export const CHECK_PAYMENT = {
  pt: "Verificar pagamento",
  es: "Verificar pago",
  en: "Check payment",
};

export const CHECK_PAYMENT_SUCCESS = {
  pt: "Verificação de pagamento solicitada com sucesso!",
  es: "¡Verificación de pago solicitada con éxito!",
  en: "Payment verification requested successfully!",
};

export const CHECK_PAYMENT_ERROR = {
  pt: "Erro ao verificar pagamento",
  es: "Error al verificar pago",
  en: "Error checking payment",
};

export const FLEET_BENEFIT = {
  pt: "Benefício frota",
  en: "Fleet benefit",
  es: "Beneficio de flota",
};

export const IDLE_FEE_FORGIVEN_VALUE = {
  pt: "Isento por primeira taxa de ociosidade",
  es: "Exención por primera tarifa de inactividad",
  en: "First idle fee waiver",
};

export const UNIFY_ACCOUNTS = {
  pt: "Unificar contas duplicadas",
  es: "Unificar cuentas duplicadas",
  en: "Unify duplicate accounts",
};

export const UNIFY_ACCOUNTS_SECONDARY_ID_PLACEHOLDER = {
  pt: "ID do MongoDB da conta secundária",
  es: "ID de MongoDB de la cuenta secundaria",
  en: "Secondary account MongoDB ID",
};

export const UNIFY_ACCOUNTS_CONFIRM = {
  pt: "Tem certeza? Essa ação é irreversível. A conta secundária será anonimizada e todos os dados serão transferidos para esta conta.",
  es: "¿Está seguro? Esta acción es irreversible. La cuenta secundaria será anonimizada y todos los datos serán transferidos a esta cuenta.",
  en: "Are you sure? This action is irreversible. The secondary account will be anonymized and all data will be transferred to this account.",
};

export const UNIFY_ACCOUNTS_SUCCESS = {
  pt: "Contas unificadas com sucesso!",
  es: "¡Cuentas unificadas con éxito!",
  en: "Accounts unified successfully!",
};

export const UNIFY_ACCOUNTS_ERROR = {
  pt: "Erro ao unificar contas",
  es: "Error al unificar cuentas",
  en: "Error unifying accounts",
};

export const UNIFY_ACCOUNTS_INFO = {
  pt: "Use este botão apenas para casos em que o usuário possui contas idênticas mas com userId diferente (contas duplicadas).",
  es: "Use este botón solo para casos en que el usuario tiene cuentas idénticas pero con userId diferente (cuentas duplicadas).",
  en: "Use this button only for cases where the user has identical accounts but with a different userId (duplicate accounts).",
};

export const APPLY_COUPON = {
  pt: "Aplicar cupom",
  es: "Aplicar cupón",
  en: "Apply coupon",
};

export const APPLY_COUPON_TITLE = {
  pt: "Aplicar cupom retroativo",
  es: "Aplicar cupón retroactivo",
  en: "Apply retroactive coupon",
};

export const APPLY_COUPON_SELECT_PLACEHOLDER = {
  pt: "Selecione um cupom",
  es: "Seleccione un cupón",
  en: "Select a coupon",
};

export const APPLY_COUPON_EMPTY = {
  pt: "Nenhum cupom disponível para esta carga",
  es: "Ningún cupón disponible para esta carga",
  en: "No coupons available for this charge",
};

export const APPLY_COUPON_CONFIRM = {
  pt: "Aplicar",
  es: "Aplicar",
  en: "Apply",
};

export const APPLY_COUPON_SUCCESS = {
  pt: "Cupom aplicado com sucesso!",
  es: "¡Cupón aplicado con éxito!",
  en: "Coupon applied successfully!",
};

export const APPLY_COUPON_ALREADY = {
  pt: "Este cupom já estava aplicado nesta carga",
  es: "Este cupón ya estaba aplicado en esta carga",
  en: "This coupon was already applied to this charge",
};

export const APPLY_COUPON_ERROR = {
  pt: "Erro ao aplicar cupom",
  es: "Error al aplicar cupón",
  en: "Error applying coupon",
};

export const APPLY_COUPON_DISCOUNT = {
  pt: "Desconto aplicado",
  es: "Descuento aplicado",
  en: "Discount applied",
};

export const APPLY_COUPON_NEW_VALUE = {
  pt: "Novo valor da carga",
  es: "Nuevo valor de la carga",
  en: "New charge value",
};

export const APPLY_COUPON_WALLET_CREDIT = {
  pt: "Crédito na carteira",
  es: "Crédito en la billetera",
  en: "Wallet credit",
};

export const APPLY_COUPON_INFO = {
  pt: "O valor do desconto será creditado na carteira do usuário.",
  es: "El valor del descuento se acreditará en la billetera del usuario.",
  en: "The discount amount will be credited to the user's wallet.",
};

export const PASSWORD = {
  pt: "Senha",
  es: "Contraseña",
  en: "Password",
};

export const GENERATE_PASSWORD_RESET_TOKEN = {
  pt: "Gerar código de recuperação de senha",
  es: "Generar código de recuperación de contraseña",
  en: "Generate password reset code",
};

export const GENERATE_PASSWORD_RESET_TOKEN_SUCCESS = {
  pt: "Código gerado com sucesso",
  es: "Código generado con éxito",
  en: "Code generated successfully",
};

export const GENERATE_PASSWORD_RESET_TOKEN_ERROR = {
  pt: "Não foi possível gerar o código",
  es: "No se pudo generar el código",
  en: "It was not possible to generate the code",
};

export const GENERATE_PASSWORD_RESET_TOKEN_INSTRUCTIONS = {
  pt: "O usuário deve usar o código abaixo no fluxo de recuperação de senha do aplicativo:",
  es: "El usuario debe usar el siguiente código en el flujo de recuperación de contraseña de la aplicación:",
  en: "The user should use the code below in the app's password recovery flow:",
};
